import { Component, OnInit, HostListener, Output, EventEmitter } from "@angular/core";
import { ThemeService } from "../../../services/theme/theme.service";
import { UserThemePreferenceService } from "../../../services/theme/user-theme-preference.service";
import { LanguageService } from "../../../services/language/language.service";
import { NotificationService } from "../../../services/notification.service";
import { UserService, User } from "../../../services/user.service";
import { AuthService } from "../../../services/auth/auth.service";
import { FrontendLoggerService } from "../../../services/frontend-logger.service";

@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: [
      "./header.component.shell-and-user-menu.scss",
      "./header.component.dropdown-and-responsive.scss"
    ],
    standalone: false
})
export class HeaderComponent implements OnInit {
  @Output() menuToggle = new EventEmitter<void>();
  currentUser: User | null = null;
  unreadNotificationsCount = 0;
  showNotifications = false;
  notifications: any[] = [];
  showUserMenu = false; // 👈 Para el dropdown del usuario

  constructor(
    public themeService: ThemeService,
    public languageService: LanguageService,
    private notificationService: NotificationService,
    private userService: UserService,
    private authService: AuthService,
    private frontendLogger: FrontendLoggerService,
    private themePreference: UserThemePreferenceService
  ) {}

  ngOnInit(): void {
    this.userService.getCurrentUser().subscribe({
      next: (user) => {
        this.currentUser = user;
        // La preferencia guardada por el usuario gana sobre la local del navegador.
        this.themePreference.applyFromProfile(user?.theme);
      },
      error: (error) => {
        this.frontendLogger.error(`[HeaderComponent] Error al cargar el usuario: ${JSON.stringify(error)}`);
      },
    });

    this.notificationService.unreadCount$.subscribe((count) => {
      this.unreadNotificationsCount = count;
    });

    this.notificationService.notifications$.subscribe((notifications) => {
      this.notifications = notifications;
    });
  }

  toggleTheme(): void {
    this.themePreference.toggle();
  }

  /** Etiqueta accesible del boton: anuncia la accion, no el estado actual. */
  themeToggleLabel(theme: string | null): string {
    return theme === "dark"
      ? this.translate("header.theme.switchToLight")
      : this.translate("header.theme.switchToDark");
  }

  toggleNotifications(): void {
    this.showNotifications = !this.showNotifications;
  }

  toggleUserMenu(): void {
    this.showUserMenu = !this.showUserMenu;
  }

  // Emitir evento para abrir/cerrar el sidebar en móvil
  onHamburgerClick(): void {
    this.menuToggle.emit();
  }

  @HostListener("document:click", ["$event"])
  onClickOutside(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const clickedInside = target.closest(".user-profile");
    if (!clickedInside) {
      this.showUserMenu = false;
    }
  }

  markAsRead(id: string): void {
    this.notificationService.markAsRead(id);
  }

  markAllAsRead(): void {
    this.notificationService.markAllAsRead();
  }

  logout(): void {
    this.authService.logout();
  }

  translate(key: string): string {
    return this.languageService.translate(key);
  }
}
